webpackJsonp([5],{

/***/ 726:
/*!************************************************!*\
  !*** ./src/pages/products/ProductVariants.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductVariants_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductVariants.vue */ 864);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b75f7b6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductVariants_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b75f7b6c","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductVariants.vue */ 937);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductVariants_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b75f7b6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductVariants_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 727:
/*!********************************************!*\
  !*** ./node_modules/lodash/_copyObject.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(/*! ./_assignValue */ 732),
    baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 728:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getPrototype.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ 401);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 729:
/*!**************************************************!*\
  !*** ./node_modules/lodash/_cloneArrayBuffer.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(/*! ./_Uint8Array */ 397);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 730:
/*!***************************************!*\
  !*** ./src/graphql/MediaFragment.gql ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Media"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Media"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":63}};
    doc.loc.source = {"body":"fragment Media on Media {\n  id kind name mime length alt data\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Media"] = oneQuery(doc, "Media");
        


/***/ }),

/***/ 731:
/*!************************************!*\
  !*** ./node_modules/lodash/map.js ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseMap = __webpack_require__(/*! ./_baseMap */ 735),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 732:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_assignValue.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    eq = __webpack_require__(/*! ./eq */ 121);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 733:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getSymbolsIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ 394),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ 395),
    stubArray = __webpack_require__(/*! ./stubArray */ 400);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 734:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getAllKeysIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ 399),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 733),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 735:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseMap.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 736:
/*!******************************************!*\
  !*** ./node_modules/lodash/_overRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(/*! ./_apply */ 769);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 737:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setToString.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(/*! ./_baseSetToString */ 770),
    shortOut = __webpack_require__(/*! ./_shortOut */ 772);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 738:
/*!*************************************!*\
  !*** ./node_modules/lodash/omit.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseClone = __webpack_require__(/*! ./_baseClone */ 747),
    baseUnset = __webpack_require__(/*! ./_baseUnset */ 763),
    castPath = __webpack_require__(/*! ./_castPath */ 119),
    copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    customOmitClone = __webpack_require__(/*! ./_customOmitClone */ 767),
    flatRest = __webpack_require__(/*! ./_flatRest */ 745),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 734);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 739:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseFlatten.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ 394),
    isFlattenable = __webpack_require__(/*! ./_isFlattenable */ 768);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 740:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneBuffer.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ 15);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 76)(module)))

/***/ }),

/***/ 741:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_copyArray.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 742:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_cloneTypedArray.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 743:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_initCloneObject.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(/*! ./_baseCreate */ 758),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    isPrototype = __webpack_require__(/*! ./_isPrototype */ 128);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 744:
/*!**********************************************!*\
  !*** ./node_modules/lodash/isPlainObject.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 39),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 745:
/*!******************************************!*\
  !*** ./node_modules/lodash/_flatRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(/*! ./flatten */ 746),
    overRest = __webpack_require__(/*! ./_overRest */ 736),
    setToString = __webpack_require__(/*! ./_setToString */ 737);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 746:
/*!****************************************!*\
  !*** ./node_modules/lodash/flatten.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(/*! ./_baseFlatten */ 739);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 747:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseClone.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ 126),
    arrayEach = __webpack_require__(/*! ./_arrayEach */ 748),
    assignValue = __webpack_require__(/*! ./_assignValue */ 732),
    baseAssign = __webpack_require__(/*! ./_baseAssign */ 749),
    baseAssignIn = __webpack_require__(/*! ./_baseAssignIn */ 750),
    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ 740),
    copyArray = __webpack_require__(/*! ./_copyArray */ 741),
    copySymbols = __webpack_require__(/*! ./_copySymbols */ 751),
    copySymbolsIn = __webpack_require__(/*! ./_copySymbolsIn */ 752),
    getAllKeys = __webpack_require__(/*! ./_getAllKeys */ 398),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 734),
    getTag = __webpack_require__(/*! ./_getTag */ 389),
    initCloneArray = __webpack_require__(/*! ./_initCloneArray */ 753),
    initCloneByTag = __webpack_require__(/*! ./_initCloneByTag */ 754),
    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ 743),
    isArray = __webpack_require__(/*! ./isArray */ 11),
    isBuffer = __webpack_require__(/*! ./isBuffer */ 125),
    isMap = __webpack_require__(/*! ./isMap */ 759),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    isSet = __webpack_require__(/*! ./isSet */ 761),
    keys = __webpack_require__(/*! ./keys */ 73),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 748:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arrayEach.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 749:
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseAssign.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    keys = __webpack_require__(/*! ./keys */ 73);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 750:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseAssignIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 751:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_copySymbols.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ 395);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 752:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_copySymbolsIn.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 733);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 753:
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneArray.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 754:
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneByTag.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729),
    cloneDataView = __webpack_require__(/*! ./_cloneDataView */ 755),
    cloneRegExp = __webpack_require__(/*! ./_cloneRegExp */ 756),
    cloneSymbol = __webpack_require__(/*! ./_cloneSymbol */ 757),
    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ 742);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 755:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_cloneDataView.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 756:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneRegExp.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 757:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneSymbol.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ 52);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 758:
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseCreate.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ 51);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 759:
/*!**************************************!*\
  !*** ./node_modules/lodash/isMap.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(/*! ./_baseIsMap */ 760),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ 392),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ 393);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 760:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsMap.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ 389),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 761:
/*!**************************************!*\
  !*** ./node_modules/lodash/isSet.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(/*! ./_baseIsSet */ 762),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ 392),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ 393);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 762:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsSet.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ 389),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 763:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnset.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ 119),
    last = __webpack_require__(/*! ./last */ 764),
    parent = __webpack_require__(/*! ./_parent */ 765),
    toKey = __webpack_require__(/*! ./_toKey */ 53);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 764:
/*!*************************************!*\
  !*** ./node_modules/lodash/last.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 765:
/*!****************************************!*\
  !*** ./node_modules/lodash/_parent.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ 127),
    baseSlice = __webpack_require__(/*! ./_baseSlice */ 766);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 766:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseSlice.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 767:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_customOmitClone.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(/*! ./isPlainObject */ 744);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 768:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_isFlattenable.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ 52),
    isArguments = __webpack_require__(/*! ./isArguments */ 124),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 769:
/*!***************************************!*\
  !*** ./node_modules/lodash/_apply.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 770:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseSetToString.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(/*! ./constant */ 771),
    defineProperty = __webpack_require__(/*! ./_defineProperty */ 402),
    identity = __webpack_require__(/*! ./identity */ 123);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 771:
/*!*****************************************!*\
  !*** ./node_modules/lodash/constant.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 772:
/*!******************************************!*\
  !*** ./node_modules/lodash/_shortOut.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 774:
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 787:
/*!************************************************************************************!*\
  !*** ./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_TableRowActions_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../../vue-loader/lib/selector?type=script&index=0!./TableRowActions.vue */ 774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a16919a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_TableRowActions_vue__ = __webpack_require__(/*! !../../../../vue-loader/lib/template-compiler/index?{"id":"data-v-3a16919a","hasScoped":false,"buble":{"transforms":{}}}!../../../../vue-loader/lib/selector?type=template&index=0!./TableRowActions.vue */ 788);
var normalizeComponent = __webpack_require__(/*! ../../../../vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_TableRowActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a16919a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_TableRowActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 788:
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a16919a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"icons-list"},[_c('li',{staticClass:"dropdown"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right"},[_vm._t("default")],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle cursor-pointer",attrs:{"data-toggle":"dropdown"}},[_c('i',{staticClass:"icon-menu9"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 789:
/*!************************************************************!*\
  !*** ./src/pages/products/graphql/ProductListFragment.gql ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":278}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment ProductList on Product {\n  id\n  name\n  createdAt\n  updatedAt\n  published\n  kind\n  preview { ...Media }\n  collection { id name }\n  variants { reference }\n  combination { id name parts { id } }\n  combinationPart { id name }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductList"] = oneQuery(doc, "ProductList");
        


/***/ }),

/***/ 790:
/*!*****************************!*\
  !*** ./src/common/types.js ***!
  \*****************************/
/*! exports provided: ProductKinds, ProductKindsArray, ProductStandards, ProductStandardsInfos, ProductStandardsArray, ProductPropertyKinds, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductDefaultProperties */
/*! exports used: ProductDefaultProperties, ProductKinds, ProductKindsArray, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductStandardsArray, ProductStandardsInfos */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductKinds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductKindsArray; });
/* unused harmony export ProductStandards */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ProductStandardsInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProductStandardsArray; });
/* unused harmony export ProductPropertyKinds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductPropertyKindsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProductPropertySexOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProductPropertySexOptionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDefaultProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/slicedToArray */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);



//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//

var ProductKinds = {
  clothing: "Vêtement",
  linen: "Linges",
  carpet: "Tapis",
  accessory: "Accessoires"
};
var ProductKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductKinds, function (label, value) {
  return {
    value: value,
    label: label
  };
});

var ProductStandards = ["ISO 20471-1", "ISO 20471-2", "ISO 20471-3", "ISO 11611-1", "ISO 11611-2", "EN 13034-6", "ISO 11612", "IEC 61482-2", "EN 1149-5", "EN 342", "EN 343", "EN 14058", "EN 14404"].sort(function (a, b) {
  // Clever sort
  var _$exec = /^(\w+)\s*(\d+)/.exec(a),
      _$exec2 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
      allA = _$exec2[0],
      nameA = _$exec2[1],
      numberA = _$exec2[2];

  var _$exec3 = /^(\w+)\s*(\d+)/.exec(b),
      _$exec4 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec3, 3),
      allB = _$exec4[0],
      nameB = _$exec4[1],
      numberB = _$exec4[2];

  return !!nameA && nameA === nameB ? parseInt(numberA || "0", 10) - parseInt(numberB || "0", 10) : a.localeCompare(b);
});

var ProductStandardsInfos = {
  "ISO 20471-1": {
    name: "ISO 20471-1 - Risque de non visibilité - Classe 1",
    icon: "iso-20471-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-2": {
    name: "ISO 20471-2 - Risque de non visibilité - Classe 2",
    icon: "iso-20471-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-3": {
    name: "ISO 20471-3 - Risque de non visibilité - Classe 3",
    icon: "iso-20471-3",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-3</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-1": {
    name: "ISO 11611-1 - Risque thermique : chaleur et flammes - Classe 1",
    icon: "iso-11611-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-2": {
    name: "ISO 11611-2 - Risque thermique : chaleur et flammes - Classe 2",
    icon: "iso-11611-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "EN 13034-6": {
    name: "EN 13034-6 - Risque produits liquides chimiques",
    icon: "en-13034-6",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Produits</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">chimiques</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 13034-6</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.1,28h10.6c0.9,0,1.5-0.2,1.8-0.7c0.5-0.7,0.1-1.6,0.1-1.6c0,0-3.2-11-3.9-13.2c-0.6-2.1-0.2-3-0.1-3.1L19.7,7\n                c0.1-0.2,0-0.4-0.2-0.4c-0.2-0.1-0.4,0-0.4,0.2L18,9c-0.1,0.1-0.6,1.1,0.1,3.6c0.2,0.6,0.6,1.9,1,3.5h-7.4c0.5-1.5,0.8-2.8,1-3.5\n                c0.7-2.4,0.2-3.5,0.1-3.5l-1.1-2.4c-0.1-0.2-0.3-0.2-0.4-0.2C11.1,6.6,11,6.8,11.1,7l1.1,2.4c0,0,0.5,0.9-0.2,3\n                c-0.7,2.3-3.9,13.2-3.9,13.2c0,0-0.4,1,0.1,1.7C8.6,27.8,9.2,28,10.1,28\"/>\n              <path d=\"M17.2,5.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1C23.8,5,23.7,5,23.5,5\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C22,5,21.9,5,21.7,5c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C20.2,5,20.1,5,19.9,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1C18.4,5,18.3,5,18.1,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1C17.1,4.8,17,4.9,17,5\n                C17,5.1,17.1,5.2,17.2,5.2\"/>\n              <path d=\"M17.2,4.4c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1C23,4.1,22.9,4,22.6,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                C21.2,4.1,21.1,4,20.8,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C19.4,4.1,19.2,4,19,4\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C17.6,4.1,17.4,4,17.2,4C17.1,4,17,4.1,17,4.2\n                C17,4.3,17.1,4.4,17.2,4.4\"/>\n              <path d=\"M19.9,3.8c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1s-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2C19.7,3.7,19.8,3.8,19.9,3.8\"/>\n              <path d=\"M24.4,5.6c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1\n                c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.3,0,0.4-0.1,0.5-0.1C20.5,6,20.6,6,20.8,6\n                c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1C22.3,6,22.4,6,22.6,6c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1s0.4-0.1,0.5-0.1C24.1,6,24.2,6,24.4,6c0.1,0,0.2-0.1,0.2-0.2C24.6,5.7,24.5,5.6,24.4,5.6\"/>\n            </g>\n          </svg>"
  },
  "ISO 11612": {
    name: "ISO 11612 - Risque soudage chaleurs et projections",
    icon: "iso-11612",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Chaleurs et</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">flammes</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11612</text>\n            <g transform=\"translate(9.55 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.9,28.3c1.3,0.4,1.5,0,1.5,0c-2.3-1-3-4.2-2-6.7c2.2,2.3,1.9-1.7,1.7-3c1.3,0.5,1.2,4.1,3.3,4.7\n                c-1.4-2.5,0.7-6.8-0.1-8.1c1.6,0.8,1.6,4.1,1.4,5.1c1.4-0.9,0.3-2.7,1.3-4.2c-0.4,1,1.2,3.7,0,5.8c1.2,0.5,1.3-2.1,2.5-1.8\n                c-0.6,0.6,0.2,2.5,0.2,4.5c0,1.6-0.8,3.1-2.2,3.8c0,0,1.1,0.1,1.5,0c2-0.6,3.5-3.2,3.5-5.7c-0.1-3.6-2.2-8.2-1.1-9.5\n                c-1.6-0.1-1.7,2.5-3.1,2.8c0.9-1.6,0.7-3.7-0.4-5.4c-0.7-1.2-0.8-2.8,0-3.5c-1.5,0.4-2.3,3-1.9,5.1c-2-3.1,0.9-6.8-0.5-9\n                c0.4,1.1-1.7,3.4-2.8,5.9c-0.9,2-0.8,5,0.2,7.7c-2.7-2.6-0.4-6.8-2.4-8c1,1.6-2.4,3.4-0.7,7.6c-0.6,0.5-1.1-1.8-2.3-1.3\n                c0.7,0.9-0.5,4.3-0.8,5.8C6.9,24.7,8.4,27.6,10.9,28.3\"/>\n            </g>\n          </svg>"
  },
  "IEC 61482-2": {
    name: "IEC 61482-2 - Risque d'arc électrique",
    icon: "iec-61482-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Arc</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xE9lectrique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">IEC 61482-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.7,16.1l7.8-11.2l7.8,11.2h-5l-2.8-4l-2.8,4H7.7z M7.1,25.5l8.3-12l8.3,12H7.1z M25.4,26.3l-6.5-9.4h6L15.5,3.5L6.1,16.9\n                h6l-6.5,9.4H25.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 1149-5": {
    name: "EN 1149-5 - Risque d'électricité statique",
    icon: "en-1149-5",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xC9lectricit\xE9</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">statique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 1149-5</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.4,26.5h16.2c0.1,0,0.2-0.1,0.2-0.2v-2c0-0.1-0.1-0.2-0.2-0.2h-7.4l4.9-13.2l-9,5.1l2.7-8.2c0,0,0,0,0.1,0\n                c1,0,1.9-0.8,1.9-1.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9c0,0.6,0.3,1.1,0.7,1.5l-3.7,11.1l8.8-5l-4,10.7H7.4\n                c-0.1,0-0.2,0.1-0.2,0.2v2C7.2,26.4,7.3,26.5,7.4,26.5\"/>\n            </g>\n          </svg>"
  },
  "EN 342": {
    name: "EN 342 - Risque froid : de -5° jusqu'à -50°C",
    icon: "en-342",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Froid</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 342</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 343": {
    name: "EN 343 - Risque intempéries",
    icon: "en-343",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Intemp\xE9ries</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 343</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n                <path d=\"M15.1,16.9c-0.9,0.1-1.5,0.5-2.1,1.2c-0.6-0.7-1.4-1.2-2.3-1.2c-1,0-1.7,0.5-2.3,1.2c-0.6-0.6-1.2-1.1-2.1-1.2\n                  c-0.9-0.1-1.6,0.2-2.2,0.8c0,0,0,0,0,0c0.1-0.3,0.1-0.5,0.2-0.8c0.4-1.1,1-2.1,1.7-2.9c1.1-1.2,2.4-2.2,4-2.8\n                  c1-0.5,2.1-0.8,3.2-0.9c0.6-0.1,1.2-0.2,1.9-0.2c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.4,0.3-0.4\n                  c0.2,0,0.4,0.1,0.4,0.3c0,0.2,0,0.4,0,0.6c0,0,0,0.1,0,0.1c0.2,0,0.3,0,0.5,0c1.1,0.1,2.2,0.3,3.3,0.6c1.4,0.4,2.6,1,3.8,1.9\n                  c1.1,0.8,1.9,1.7,2.6,2.9c0.4,0.8,0.8,1.8,0.9,2.5c-0.6-0.7-1.4-1.1-2.3-1.1c-0.9,0-1.6,0.5-2.3,1.2c-0.6-0.7-1.4-1.2-2.3-1.2\n                  c-1,0-1.7,0.5-2.3,1.2c-0.5-0.6-1.1-1-1.9-1.1c0,0,0,0.1,0,0.1c0,3.3,0,6.5,0,9.8c0,0.2,0,0.4,0.1,0.6c0.2,0.5,0.5,0.6,1.1,0.6\n                  c0.3,0,0.6-0.2,0.7-0.5c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3\n                  c0,0.7-0.1,1.4-0.7,1.9c-0.2,0.2-0.4,0.2-0.7,0.3c-0.4,0-0.8,0-1.2-0.2c-0.4-0.2-0.7-0.6-0.8-1.1c-0.1-0.2-0.1-0.4-0.1-0.6\n                  c0-3.3,0-6.5,0-9.8C15.1,17,15.1,17,15.1,16.9z\"/>\n              <path d=\"M18.6,8.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S18.9,8.4,18.6,8.7z\"/>\n              <path d=\"M17.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S17.7,6.2,17.4,6.4z\"/>\n              <path d=\"M24.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1S25,4.9,25,4.9S24.7,6.2,24.4,6.4z\"/>\n              <path d=\"M21.2,4.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S21.5,4.5,21.2,4.7z\"/>\n              <path d=\"M13.9,7.9c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S14.1,7.7,13.9,7.9z\"/>\n              <path d=\"M21.2,6.7c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S21.5,6.5,21.2,6.7z\"/>\n              <path d=\"M21.7,9.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S22,9.2,21.7,9.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 14058": {
    name: "EN 14058 - Risque frais : au dessus de -5°C",
    icon: "en-14058",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Frais</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14058</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 14404": {
    name: "EN 14404 - Risque hygroma du genoux",
    icon: "en-14404",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Genoux</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14404</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M16.2,20.5H7.9v-8.5h3.7c0.2-0.1,0.2-1,0.2-1.5c0-1,0-2.2,0.7-2.9C12.9,7.2,13.3,7,13.9,7h2.3v5.8h9.5V14h-9.5v1.6h9.5v1.1\n                h-9.5V20.5z\"/>\n              <rect x=\"5.2\" y=\"22.3\" width=\"13.2\" height=\"2.3\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  }
};

var ProductStandardsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductStandards, function (value) {
  return {
    value: value,
    label: (ProductStandardsInfos[value] || { name: value }).name
  };
});

var ProductPropertyKinds = {
  tag: "Choix prédéfini",
  sex: "Sexe",
  color: "Couleur",
  text: "Texte libre"
};
var ProductPropertyKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertyKinds, function (label, value) {
  return { value: value, label: label };
});

var ProductPropertySexOptions = {
  male: "Homme",
  female: "Femme",
  unisex: "Unisexe"
};
var ProductPropertySexOptionsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertySexOptions, function (label, value) {
  return { value: value, label: label };
});

var ProductDefaultProperties = {
  clothing: [{ name: "Sexe", kind: "sex", required: true },
  //{name: 'Classe', kind: 'tag', required: false},
  //{name: 'Type', kind: 'tag', required: false},
  { name: "Matière", kind: "tag", required: false, tags: ["PC", "CR"] }, { name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Liseré", kind: "color", required: false, colors: [] }, { name: "Parement", kind: "color", required: false, colors: [] }],
  carpet: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, { name: "Format", kind: "tag", tags: ["Portrait", "Paysage"] }],
  linen: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, {
    name: "Volant",
    kind: "tag",
    required: false,
    tags: ["Avec volant", "Sans volant"]
  }, { name: "Données techniques", kind: "text", required: false }],
  accessory: []
};

/***/ }),

/***/ 792:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductDetailFragment.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"standards"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":259}};
    doc.loc.source = {"body":"#import \"./ProductListFragment.gql\"\n\nfragment ProductDetail on Product {\n  ...ProductList\n  order\n  fullImage\n  combination { id name }\n  combinationPart { id name }\n  properties { id name kind required colors { id name } tags }\n  images { id }\n  standards\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductListFragment.gql */ 789).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductDetail"] = oneQuery(doc, "ProductDetail");
        


/***/ }),

/***/ 798:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayIncludes.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ 809);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 799:
/*!***************************************************!*\
  !*** ./node_modules/lodash/_arrayIncludesWith.js ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 806:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductUpdateMutation.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetail"},"directives":[]}]}}]}}],"loc":{"start":0,"end":148}};
    doc.loc.source = {"body":"#import \"./ProductDetailFragment.gql\"\n\nmutation($id: ID!, $data: ProductInput) {\n  productUpdate(id: $id, data: $data) {\n    ...ProductDetail\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductDetailFragment.gql */ 792).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 809:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIndexOf.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ 810),
    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ 811),
    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ 812);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 810:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseFindIndex.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 811:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsNaN.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 812:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_strictIndexOf.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 813:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseUniq.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ 406),
    arrayIncludes = __webpack_require__(/*! ./_arrayIncludes */ 798),
    arrayIncludesWith = __webpack_require__(/*! ./_arrayIncludesWith */ 799),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ 408),
    createSet = __webpack_require__(/*! ./_createSet */ 814),
    setToArray = __webpack_require__(/*! ./_setToArray */ 404);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 814:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_createSet.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(/*! ./_Set */ 412),
    noop = __webpack_require__(/*! ./noop */ 815),
    setToArray = __webpack_require__(/*! ./_setToArray */ 404);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 815:
/*!*************************************!*\
  !*** ./node_modules/lodash/noop.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 835:
/*!*************************************!*\
  !*** ./node_modules/lodash/pick.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(/*! ./_basePick */ 918),
    flatRest = __webpack_require__(/*! ./_flatRest */ 745);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 864:
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/ProductVariants.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/toConsumableArray */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick__ = __webpack_require__(/*! lodash/pick */ 835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit__ = __webpack_require__(/*! lodash/omit */ 738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_uniq__ = __webpack_require__(/*! lodash/uniq */ 921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_ProductVariantsQuery_gql__ = __webpack_require__(/*! ./graphql/ProductVariantsQuery.gql */ 922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_ProductVariantsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_ProductVariantsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_ProductUpdateMutation_gql__ = __webpack_require__(/*! ./graphql/ProductUpdateMutation.gql */ 806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_ProductUpdateMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__graphql_ProductUpdateMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_types__ = __webpack_require__(/*! ../../common/types */ 790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PublishingStatus__ = __webpack_require__(/*! ../../components/PublishingStatus */ 411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ColorBadge__ = __webpack_require__(/*! ../../components/ColorBadge */ 135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_package_common_vuejs_src_components_table_TableRowActions__ = __webpack_require__(/*! package-common-vuejs/src/components/table/TableRowActions */ 787);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormStickyHeader: function FormStickyHeader() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormStickyHeader.vue */ 396));
    },
    Modal: function Modal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/Modal */ 132));
    },
    VariantsGeneratorForm: function VariantsGeneratorForm() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, /*! ./VariantsGeneratorForm */ 924));
    },
    ProductVariantForm: function ProductVariantForm() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, /*! ./ProductVariantForm */ 929));
    },
    MediaImage: function MediaImage() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/MediaImage */ 409));
    },
    ColorBadge: __WEBPACK_IMPORTED_MODULE_12__components_ColorBadge__["default"],
    PublishingStatus: __WEBPACK_IMPORTED_MODULE_11__components_PublishingStatus__["default"],
    TableRowActions: __WEBPACK_IMPORTED_MODULE_13_package_common_vuejs_src_components_table_TableRowActions__["a" /* default */]
  },
  data: function data() {
    return {
      product: null,

      variantsGeneratorVisible: false,
      createVariantVisible: false,
      editVariantVisible: null
    };
  },

  apollo: {
    product: {
      query: __WEBPACK_IMPORTED_MODULE_8__graphql_ProductVariantsQuery_gql___default.a,
      skip: function skip() {
        return !this.$route.params.id;
      },
      variables: function variables() {
        return this.$route.params;
      }
    }
  },
  computed: {
    pageTitle: function pageTitle() {
      if (!this.product) {
        return "D\xE9clinaisons d'un produit";
      }
      return "D\xE9clinaisons du produit " + this.product.name;
    },
    productProperties: function productProperties() {
      return this.product && this.product.properties || [];
    }
  },
  methods: {
    getAttributeValueForVariant: function getAttributeValueForVariant(variant, propertyToDisplay) {
      var propertyInfos = (variant && variant.attributes || []).find(function (_ref) {
        var property = _ref.property;
        return property === propertyToDisplay.id;
      });
      if (!propertyInfos) {
        return "-";
      }
      switch (propertyToDisplay.kind) {
        case "color":
          if (!propertyInfos.value) return '-';
          var color = (propertyToDisplay.colors || []).find(function (_ref2) {
            var id = _ref2.id;
            return id === propertyInfos.value;
          });
          if (!color) return "(couleur non disponible)";
          return color.name || '-';
        case "sex":
          return propertyInfos.value ? __WEBPACK_IMPORTED_MODULE_10__common_types__["e" /* ProductPropertySexOptions */][propertyInfos.value] : '-';
      }
      return propertyInfos.value || '-';
    },
    getColorForVariant: function getColorForVariant(variant, propertyToDisplay) {
      var propertyInfos = (variant && variant.attributes || []).find(function (_ref3) {
        var property = _ref3.property;
        return property === propertyToDisplay.id;
      });
      if (!propertyInfos) return null;
      if (propertyToDisplay.kind !== "color") return null;
      var color = (propertyToDisplay.colors || []).find(function (_ref4) {
        var id = _ref4.id;
        return id === propertyInfos.value;
      });
      if (!color) return null;
      return color;
    },
    openVariantsGenerator: function openVariantsGenerator() {
      this.variantsGeneratorVisible = true;
    },
    hideVariantsGenerator: function hideVariantsGenerator() {
      this.variantsGeneratorVisible = false;
    },
    openCreateNewVariant: function openCreateNewVariant() {
      this.createVariantVisible = true;
    },
    hideCreateNewVariant: function hideCreateNewVariant() {
      this.createVariantVisible = false;
    },
    openEditVariant: function openEditVariant(variant) {
      this.editVariantVisible = variant;
    },
    hideEditVariant: function hideEditVariant() {
      this.editVariantVisible = null;
    },
    saveVariants: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(variants) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  variants: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(variants, function (variant) {
                    return __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(variant, ["__typename"]), {
                      image: variant.image ? variant.image.id || variant.image : null,
                      attributes: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(variant.attributes, function (attrs) {
                        return __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(attrs, ["__typename"]);
                      }),
                      pins: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(variant.pins, function (pin) {
                        return __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(pin, ["__typename"]), {
                          image: typeof pin.image !== "string" ? pin.image.id : pin.image
                        });
                      })
                    });
                  })
                };
                // Ajoute les nouvelles images à la liste

                data.images = __WEBPACK_IMPORTED_MODULE_7_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.product.images || [], "id")), __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(data.variants, "image")))).filter(function (image) {
                  return !!image;
                });
                _context.prev = 2;
                _context.next = 5;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_9__graphql_ProductUpdateMutation_gql___default.a,
                  variables: {
                    id: this.product.id,
                    data: data
                  }
                });

              case 5:
                this.$store.dispatch("addNotificationSuccess", "Les d\xE9clinaisons ont \xE9t\xE9 enregistr\xE9es\xA0!");
                this.hideVariantsGenerator();
                this.$apollo.queries.product.refresh();
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                this.$store.dispatch("addNotificationError", _context.t0.message);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function saveVariants(_x) {
        return _ref5.apply(this, arguments);
      }

      return saveVariants;
    }(),
    deleteVariant: function deleteVariant(variant) {
      return this.saveVariants((this.product.variants || []).filter(function (_ref6) {
        var id = _ref6.id;
        return variant.id !== id;
      }));
    },
    addVariant: function addVariant(variant) {
      this.hideCreateNewVariant();
      return this.saveVariants([variant].concat(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.product.variants || [])));
    },
    editVariant: function editVariant(variant) {
      this.hideEditVariant();
      var variants = this.product.variants || [];
      var variantIndex = variants.findIndex(function (_ref7) {
        var id = _ref7.id;
        return id === variant.id;
      });
      return this.saveVariants([].concat(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(variants.slice(0, variantIndex)), [variant], __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(variants.slice(variantIndex + 1))));
    },
    setVariantPublished: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(variant) {
        var published = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var variants, variantIndex, newVariants, data;
        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                variants = this.product.variants || [];
                variantIndex = variants.findIndex(function (_ref9) {
                  var id = _ref9.id;
                  return id === variant.id;
                });
                newVariants = [].concat(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(variants.slice(0, variantIndex)), [__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, variant, { published: published })], __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(variants.slice(variantIndex + 1)));
                data = {
                  variants: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(newVariants, function (variant) {
                    return __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(variant, ["__typename"]), {
                      image: variant.image ? variant.image.id || variant.image : null,
                      attributes: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(variant.attributes, function (attrs) {
                        return __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(attrs, ["__typename"]);
                      }),
                      pins: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(variant.pins, function (pin) {
                        return __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(pin, ["__typename"]), {
                          image: typeof pin.image !== "string" ? pin.image.id : pin.image
                        });
                      })
                    });
                  })
                };
                _context2.prev = 4;
                _context2.next = 7;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_9__graphql_ProductUpdateMutation_gql___default.a,
                  variables: {
                    id: this.product.id,
                    data: data
                  }
                });

              case 7:
                this.$apollo.queries.product.refresh();
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);

                this.$store.dispatch("addNotificationError", _context2.t0.message);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function setVariantPublished(_x3) {
        return _ref8.apply(this, arguments);
      }

      return setVariantPublished;
    }()
  }
});

/***/ }),

/***/ 918:
/*!******************************************!*\
  !*** ./node_modules/lodash/_basePick.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(/*! ./_basePickBy */ 919),
    hasIn = __webpack_require__(/*! ./hasIn */ 419);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 919:
/*!********************************************!*\
  !*** ./node_modules/lodash/_basePickBy.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ 127),
    baseSet = __webpack_require__(/*! ./_baseSet */ 920),
    castPath = __webpack_require__(/*! ./_castPath */ 119);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 920:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseSet.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(/*! ./_assignValue */ 732),
    castPath = __webpack_require__(/*! ./_castPath */ 119),
    isIndex = __webpack_require__(/*! ./_isIndex */ 129),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    toKey = __webpack_require__(/*! ./_toKey */ 53);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 921:
/*!*************************************!*\
  !*** ./node_modules/lodash/uniq.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(/*! ./_baseUniq */ 813);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 922:
/*!*************************************************************!*\
  !*** ./src/pages/products/graphql/ProductVariantsQuery.gql ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"productFetchById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductVariants"},"directives":[]}]}}]}}],"loc":{"start":0,"end":127}};
    doc.loc.source = {"body":"#import \"./ProductVariantsFragment.gql\"\n\nquery($id: ID!) {\n  product: productFetchById(id: $id) {\n    ...ProductVariants\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductVariantsFragment.gql */ 923).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 923:
/*!****************************************************************!*\
  !*** ./src/pages/products/graphql/ProductVariantsFragment.gql ***!
  \****************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductVariants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"y"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}}]}}],"loc":{"start":0,"end":402}};
    doc.loc.source = {"body":"#import \"./ProductListFragment.gql\"\n#import \"../../../graphql/MediaFragment.gql\"\n\nfragment ProductVariants on Product {\n  ...ProductList\n  properties { id name kind required colors { id name colors kind group { name } } tags }\n  variants { id reference description message messageType published image { ...Media } attributes { property value } pins { x y image { ...Media } } }\n  images { ...Media }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductListFragment.gql */ 789).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductVariants"] = oneQuery(doc, "ProductVariants");
        


/***/ }),

/***/ 937:
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b75f7b6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductVariants.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[(_vm.variantsGeneratorVisible)?_c('modal',{attrs:{"title":"Génération des déclinaisons"},on:{"close":_vm.hideVariantsGenerator}},[_c('variants-generator-form',{attrs:{"value":_vm.product},on:{"submit":_vm.saveVariants,"cancel":_vm.hideVariantsGenerator}})],1):_vm._e(),_vm._v(" "),(_vm.createVariantVisible)?_c('modal',{attrs:{"title":"Ajout d'une déclinaison"},on:{"close":_vm.hideCreateNewVariant}},[_c('product-variant-form',{attrs:{"value":{published: false},"product":_vm.product},on:{"submit":_vm.addVariant,"cancel":_vm.hideCreateNewVariant}})],1):_vm._e(),_vm._v(" "),(_vm.editVariantVisible)?_c('modal',{attrs:{"title":"Édition d'une déclinaison"},on:{"close":_vm.hideEditVariant}},[_c('product-variant-form',{attrs:{"value":_vm.editVariantVisible,"product":_vm.product},on:{"submit":_vm.editVariant,"cancel":_vm.hideEditVariant}})],1):_vm._e(),_vm._v(" "),_c('panel',{attrs:{"light":""}},[_c('h5',{staticClass:"panel-title",attrs:{"slot":"heading"},slot:"heading"},[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('div',{staticClass:"heading-elements",attrs:{"slot":"heading"},slot:"heading"},[_c('div',{staticClass:"heading-buttons"},[_c('router-link',{staticClass:"btn btn-default btn-link",attrs:{"to":{name: 'product/edit', params: {id: _vm.product.id}}}},[_c('i',{staticClass:"icon-pencil position-left"}),_vm._v("Modifier le produit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.openVariantsGenerator}},[_vm._v("Générer des déclinaisons")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.openCreateNewVariant}},[_vm._v("Ajouter une déclinaison")])],1)]),_vm._v(" "),_c('div',{staticClass:"table-responsive",attrs:{"slot":"content"},slot:"content"},[_c('table',{staticClass:"table table-striped table-lg"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"135"}},[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Référence / Description")]),_vm._v(" "),_vm._l((_vm.productProperties),function(property){return _c('th',{key:property.id},[_vm._v("\n            "+_vm._s(property.name)+"\n          ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"100"}},[_vm._v("Statut")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"80"}},[_vm._v("Actions")])],2)]),_vm._v(" "),(_vm.product.variants.length)?_c('tbody',_vm._l((_vm.product.variants),function(variant,index){return _c('tr',{key:variant.id || index},[_c('td',{staticClass:"centered"},[_c('media-image',{attrs:{"media":variant.image,"empty-label":"Pas d'image","thumbnail":""}})],1),_vm._v(" "),_c('td',[_c('h6',{staticClass:"no-margin text-semibold"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.openEditVariant(variant)}}},[_vm._v(_vm._s(variant.reference || '(aucune référence)'))])]),_vm._v(" "),(variant.description)?_c('p',{staticClass:"no-margin text-muted",domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(variant.description))}}):_vm._e()]),_vm._v(" "),_vm._l((_vm.productProperties),function(property){return _c('td',{key:property.id,staticClass:"text-nowrap"},[(property.kind === 'color' && _vm.getAttributeValueForVariant(variant, property) !== '-')?_c('div',{staticClass:"valign-middle mr-5 img-thumbnail"},[_c('color-badge',{attrs:{"size":"small","color":_vm.getColorForVariant(variant, property)}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"valign-middle"},[_vm._v(_vm._s(_vm.getAttributeValueForVariant(variant, property)))])])}),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('publishing-status',{staticClass:"cursor-pointer",attrs:{"value":variant.published},on:{"hide":function($event){return _vm.setVariantPublished(variant, false)},"show":function($event){return _vm.setVariantPublished(variant)}}})],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c("table-row-actions",{tag:"ul"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.openEditVariant(variant)}}},[_c('i',{staticClass:"icon-pencil7"}),_vm._v(" Modifier")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.deleteVariant(variant)}}},[_c('i',{staticClass:"icon-bin"}),_vm._v(" Supprimer")])])])],1)],2)}),0):_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":4 + _vm.productProperties.length}},[_c('h4',[_vm._v("Aucune déclinaison")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.openVariantsGenerator}},[_vm._v("Générer des déclinaisons")])])])])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 5.5dcb90e0.chunk.js